import { GenerarReporteProductosPDF } from '../ReporteCatalogoProductos';
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../../../componentes/contenedores/Card";
import Page from "../../../../componentes/plantilla/Page";
import {
  ProductosCodigo,
  ProductosListar,
  ProductosNombre,
} from "../../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import EditarImagenesProducto from "../EditarImagenesProducto";
import TablaEditarProductos from "./TablaEditarProducto";

const HomeEditarProductos = () => {
  const { listaProductos,listaTiposProductos, setListaProductos, ActualizarLista } = useContextEmpleado();
  const { token } = useContextUsuario();
  const [busqueda, setBusqueda] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState("nombre");
  const [errorBusqueda, setErrorBusqueda] = useState(false);
  const [panelAbierto, setPanelAbierto] = useState(false);
  const [categoriaFiltro, setCategoriaFiltro] = useState("");
  const [productosFiltrados, setProductosFiltrados] = useState([]);

  const datos = {
    titulo: {
      titulo: "Edicion de productos",
      url: "/app/admin/productos/gestionar",
      tituloUrl: "productos",
      nombreUrl: "editar",
    },
  };

  useEffect(() => {
    ActualizarLista(ProductosListar, setListaProductos);
  }, []);

  useEffect(() => {
    const handleBuscar = () => {
      if (!busqueda) {
        ActualizarLista(ProductosListar, setListaProductos);
      } else if (busqueda.length >= 3) {
        setErrorBusqueda(false);
        if (tipoBusqueda === "codigo") {
          ActualizarLista(ProductosCodigo + busqueda, setListaProductos);
        } else if (tipoBusqueda === "nombre") {
          ActualizarLista(ProductosNombre + busqueda, setListaProductos);
        }
      }
    };
    handleBuscar();
  }, [busqueda, tipoBusqueda]);

  useEffect(() => {
    let listaFiltrada = listaProductos;

    if (categoriaFiltro && categoriaFiltro !== "") {
      const categoriaIdNumerica = parseInt(categoriaFiltro);

      listaFiltrada = listaFiltrada.filter(producto => {
        return producto.productoTipoId === categoriaIdNumerica;
      });
    }
    setProductosFiltrados(listaFiltrada);

  }, [listaProductos, categoriaFiltro]);

  const handleFiltrar = () => {
    setPanelAbierto(false);
  };

  const handleReset = () => {
    setCategoriaFiltro("");
    setPanelAbierto(false);
  };

  const renderFilterPanel = () => (
    <div className="mb-4 d-flex justify-content-end">
      <div className="position-relative">
        <button
          className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
          onClick={() => setPanelAbierto(!panelAbierto)}
          style={{
            borderRadius: "6px",
            padding: "6px 12px",
            fontSize: "0.9rem",
            minWidth: "140px",
          }}
        >
          <span className="d-flex align-items-center">
            <i className="fas fa-filter mx-2"></i>
            Filtros
          </span>
          <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
        </button>

        {panelAbierto && (
          <div
            className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
            style={{
              minWidth: "280px",
              right: 0,
              borderRadius: "10px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              padding: "15px",
              zIndex: 1050,
            }}
          >
            <div className="form-group mb-3">
              <label htmlFor="filtroCategoriaSelect" className="form-label fw-bold">Categoría</label>
              <select
                id="filtroCategoriaSelect"
                className="form-control form-control-sm"
                value={categoriaFiltro}
                onChange={(e) => setCategoriaFiltro(e.target.value)}
              >
                <option value="">Todas las categorías</option>
                {listaTiposProductos?.map((tipo) => (
                  <option key={tipo.id} value={String(tipo.id)}>
                    {tipo.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex">
              <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                <i className="fas fa-filter mx-1"></i> Filtrar
              </button>
              <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                <i className="fas fa-sync-alt mx-1"></i> Reset
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Page datos={datos}>
      <Card
        titulo="Módulo para editar productos"
        pie={
          <Link to={"/app/admin/productos/nuevo"}>
            <button className="btn btn-info d-flex align-items-center gap-2 px-3 py-2 fw-bold shadow-sm rounded">
              <span>Nuevo Producto</span>
              <i className="fas fa-box mx-2"></i>
            </button>
          </Link>
        }
      >
        <div>
          <p className="card-text">
            Este módulo permite editar productos. Selecciona un producto de la tabla para modificar sus imágenes.
          </p>
        </div>
      </Card>
      <Card titulo="Editar Productos">
        {renderFilterPanel()}
        <TablaEditarProductos
          datos={productosFiltrados}
        />
      </Card>
    </Page>
  );
};

export default HomeEditarProductos;